import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    stickers(params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/stickers/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    pdfs(warehouse, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/stickers_pdfs/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    create_pdf(params) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/stickers/",
          data: { ...params }
        })
      )
        .then(blob => {
          var binaryData = [];
          binaryData.push(blob.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/*"
            })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = params.stickers.join('-') + '.pdf';
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        })
        .catch(err => {
          throw err;
        });
    },
    download(id) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "GET",
          url: API_BASE + `/stickers_pdfs/${id}/`
        })
      )
        .then(blob => {
          var binaryData = [];
          binaryData.push(blob.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/*"
            })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = `${id}.pdfs`;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        })
        .catch(err => {
          throw err;
        });
    }
  };
};
